/**
 * Row — a row of 5 tiles representing one guess.
 */
import React from 'react';
import Tile from './Tile';
import { WORD_LENGTH, TILE_STATE } from '../../utils/constants';

const Row = ({ guess = '', evaluation = [], isCurrentRow = false, shakeRow = false, isWinRow = false }) => {
  const letters = [...guess];

  const tiles = [];
  for (let i = 0; i < WORD_LENGTH; i++) {
    const letter = letters[i] || '';
    const state = evaluation[i] || (letter ? TILE_STATE.TBD : TILE_STATE.EMPTY);

    tiles.push(
      <Tile
        key={i}
        letter={letter}
        state={state}
        delay={i * 300}
        shouldBounce={isWinRow}
        bounceDelay={i * 100 + 1800}
      />
    );
  }

  return (
    <div
      className={`flex gap-1.5 justify-center ${
        shakeRow && isCurrentRow ? 'row-shake' : ''
      }`}
    >
      {tiles}
    </div>
  );
};

export default React.memo(Row);
